import { Effect, Reducer } from 'umi';
import {
  getFeedsComments,
  getFeedsSearchComments,
  getFeedsKeyword,
  getFeedsStats,
} from '@/pages/opinion/services/feeds';
import { overviewOriginType } from '../../types/performance';
import { getRealtimeFeedsKeyword } from '@op/services/realtime';

const namespace = 'opinionFeeds';

type stateType = {
  [key: string]: any;
};

function* getFeedsCommentsFactory(
  model: string,
  isSearch: boolean = false,
  put: any,
  payload: any,
) {
  const method = isSearch ? getFeedsSearchComments : getFeedsComments;

  try {
    const res: overviewOriginType = yield method({
      ...payload,
    });

    yield put({
      type: 'save',
      payload: {
        [model]: res,
      },
    });
  } catch {
    yield put({
      type: 'save',
      payload: {
        [model]: [],
      },
    });
  }
}

const customModel: {
  effects: {
    [key: string]: Effect;
  };
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    keyword: [],
  },
  reducers: {
    save(state: stateType, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    *getFeedsKeyword({ payload, cancelCallback = () => { } }, { put }) {
      const { model = 'keyword' } = payload;
      try {
        const res: overviewOriginType = yield getFeedsKeyword(
          {
            ...payload,
          },
          cancelCallback,
        );

        yield put({
          type: 'save',
          payload: {
            [model]: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            [model]: [],
          },
        });
      }
    },

    *getFeedsStats({ payload }, { put }) {
      try {
        const { model = 'stats' } = payload;

        const res: overviewOriginType = yield getFeedsStats({
          ...payload,
        });

        yield put({
          type: 'save',
          payload: {
            [model]: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            keyMetrics: [],
          },
        });
      }
    },

    getFeedsSocialMediaComments({ payload }, { put }) {
      return getFeedsCommentsFactory(
        'feedsSocialMediaComments',
        false,
        put,
        payload,
      );
    },

    getFeedsSocialMediaSearchComments({ payload }, { put }) {
      return getFeedsCommentsFactory(
        'feedsSocialMediaSearchComments',
        true,
        put,
        payload,
      );
    },

    getFeedsNewsMediaComments({ payload }, { put }) {
      return getFeedsCommentsFactory(
        'feedsNewsMediaComments',
        false,
        put,
        payload,
      );
    },

    getFeedsNewsMediaSearchComments({ payload }, { put }) {
      return getFeedsCommentsFactory(
        'feedsNewsMediaSearchComments',
        true,
        put,
        payload,
      );
    },

    *getRealtimeFeedsKeyword({ payload, cancelCallback = () => { } }, { put }) {
      const { model = 'keyword' } = payload;
      try {
        const res: overviewOriginType = yield getRealtimeFeedsKeyword(
          {
            ...payload,
          },
          cancelCallback,
        );

        yield put({
          type: 'save',
          payload: {
            [model]: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            [model]: [],
          },
        });
      }
    },
  },
};

export default customModel;
